import { ReactNode, useState } from "react";

import CustomerAttribute, {
  CustomerAttributeProps,
} from "~/components/common/CustomerAttribute";

type Props = CustomerAttributeProps & {
  renderEditForm: (onDone: () => void) => ReactNode;
};

// extends CustomerAttribute component to make it editable
// receives a renderEditForm function that returns a ReactNode
// the renderEditForm function receives a onDone function that should be called when the edit is done or cancelled
export function EditableCustomerAttribute({
  isCopyable,
  renderEditForm,
  children,
  ...restProps
}: Props) {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <CustomerAttribute
      {...restProps}
      onEdit={() => setIsEditing((isEditing) => !isEditing)}
      // disable copying when editing since it overlaps with the form elements
      // and doesn't make sense to copy the value when editing
      isCopyable={isEditing ? false : isCopyable}
    >
      {isEditing ? renderEditForm(() => setIsEditing(false)) : children}
    </CustomerAttribute>
  );
}
